import {
  booleanT,
  defineContract,
  listT,
  noneT,
  numberT,
  optionalT,
  principalT,
  responseSimpleT,
  tupleT,
} from "../smartContractHelpers/codegenImport"

export const dualFarmingPoolV103 = defineContract({
  "dual-farming-pool-v1-03": {
    "add-token": {
      input: [
        { name: "token", type: principalT },
        { name: "dual-token", type: principalT },
        { name: "multiplier-in-fixed", type: numberT },
        { name: "start-cycle", type: numberT },
      ],
      output: responseSimpleT(booleanT),
      mode: "public",
    },
    "claim-and-mint-auto-alex": {
      input: [
        { name: "dual-token-trait", type: principalT },
        { name: "reward-cycles", type: listT(numberT) },
      ],
      output: responseSimpleT(
        listT(
          responseSimpleT(
            tupleT({
              "entitled-dual": numberT,
              "entitled-token": numberT,
              "to-return": numberT,
            }),
          ),
        ),
      ),
      mode: "public",
    },
    "claim-staking-reward": {
      input: [
        { name: "token", type: principalT },
        { name: "dual-token", type: principalT },
        { name: "reward-cycles", type: listT(numberT) },
      ],
      output: responseSimpleT(
        listT(
          responseSimpleT(
            tupleT({
              "entitled-dual": numberT,
              "entitled-token": numberT,
              "to-return": numberT,
            }),
          ),
        ),
      ),
      mode: "public",
    },
    "claim-staking-reward-by-auto-alex": {
      input: [
        { name: "dual-token-trait", type: principalT },
        { name: "target-cycle", type: numberT },
      ],
      output: responseSimpleT(
        tupleT({
          "entitled-dual": numberT,
          "entitled-token": numberT,
          "to-return": numberT,
        }),
      ),
      mode: "public",
    },
    "claim-staking-reward-by-tx-sender": {
      input: [
        { name: "token-trait", type: principalT },
        { name: "dual-token-trait", type: principalT },
        { name: "target-cycle", type: numberT },
      ],
      output: responseSimpleT(
        tupleT({
          "entitled-dual": numberT,
          "entitled-token": numberT,
          "to-return": numberT,
        }),
      ),
      mode: "public",
    },
    "set-contract-owner": {
      input: [{ name: "owner", type: principalT }],
      output: responseSimpleT(booleanT),
      mode: "public",
    },
    "set-dual-token-or-fail": {
      input: [
        { name: "token", type: principalT },
        { name: "new-dual-token", type: principalT },
      ],
      output: responseSimpleT(booleanT),
      mode: "public",
    },
    "set-multiplier-in-fixed": {
      input: [
        { name: "token", type: principalT },
        { name: "new-multiplier-in-fixed", type: numberT },
      ],
      output: responseSimpleT(booleanT),
      mode: "public",
    },
    "set-start-cycle": {
      input: [
        { name: "token", type: principalT },
        { name: "new-start-cycle", type: numberT },
      ],
      output: responseSimpleT(booleanT),
      mode: "public",
    },
    "get-contract-owner": {
      input: [],
      output: responseSimpleT(principalT),
      mode: "readonly",
    },
    "get-dual-token-or-fail": {
      input: [{ name: "token", type: principalT }],
      output: responseSimpleT(principalT),
      mode: "readonly",
    },
    "get-multiplier-by-cycle-or-default": {
      input: [
        { name: "token", type: principalT },
        { name: "target-cycle", type: numberT },
      ],
      output: numberT,
      mode: "readonly",
    },
    "get-multiplier-in-fixed-or-default": {
      input: [{ name: "token", type: principalT }],
      output: numberT,
      mode: "readonly",
    },
    "get-pair-details": {
      input: [{ name: "token", type: principalT }],
      output: optionalT(
        tupleT({
          "dual-token": principalT,
          "multiplier-in-fixed": numberT,
          "start-cycle": numberT,
        }),
      ),
      mode: "readonly",
    },
    "get-pair-details-or-fail": {
      input: [{ name: "token", type: principalT }],
      output: responseSimpleT(
        tupleT({
          "dual-token": principalT,
          "multiplier-in-fixed": numberT,
          "start-cycle": numberT,
        }),
      ),
      mode: "readonly",
    },
    "get-start-cycle-or-default": {
      input: [{ name: "token", type: principalT }],
      output: numberT,
      mode: "readonly",
    },
    "approved-pair": {
      input: principalT,
      output: optionalT(
        tupleT({
          "dual-token": principalT,
          "multiplier-in-fixed": numberT,
          "start-cycle": numberT,
        }),
      ),
      mode: "mapEntry",
    },
    "contract-owner": { input: noneT, output: principalT, mode: "variable" },
  },
} as const)
